import React from "react";
import "../Navigation/css/NavBar.scss";
import {Black} from "../../theme/styles";
import subscriptions from "../../assets/subscriptions.png";
import subscriptionList from "../../assets/subscriptionList.png";
import newSubscription from "../../assets/newSubscription.png";
import editSubscription from "../../assets/editSubscription.png";
import deleteSubscription from "../../assets/deleteSubscription.png";
import subscriptionCommunicationDetail from "../../assets/subscriptionCommunicationDetail.png"

export default function Subscriptions() {
    return (
        <div style={{paddingLeft: "20px", paddingRight: "30px"}}>
            <p style={{fontSize: "24px", fontWeight: "400", color: Black}}>Subscriptions</p>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Enlil enables the ability to subscribe to an event generated within Enlil and receive a POST action to a URL with an IDOC of the -002 type relevant to the particular action. To access Subscriptions do the following:</p>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Enlil captures the contents of all transmissions to the given URL for a subscription as well as records the response details. To view the details of each transmission, double click on a given row.</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    Login to developer.enlil.io using a valid enlil username/password.
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    Navigate to the Dashboard section.
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    Navigate to the Subscription Management section
                    <br/><br/>
                    <img alt="Subscription Management" src={subscriptions} style={{objectFit: "contain", width: "1000px"}}/>
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    Subscriptions are presented in chronologically descending order.
                    <br/><br/>
                    <img alt="Subscription List" src={subscriptionList} style={{objectFit: "contain", width: "1000px"}}/>
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    To create a new subscription, click on the New Subscription menu.
                    <br/><br/>
                    <img alt="New Subscription" src={newSubscription} style={{objectFit: "contain", width: "1000px"}}/>
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    To edit a new subscription, click on the Edit Subscription menu.
                    <br/><br/>
                    <img alt="Edit Subscription" src={editSubscription} style={{objectFit: "contain", width: "1000px"}}/>
                </li>s
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    To delete a new subscription, click on the Delete Subscription menu.
                    <br/><br/>
                    <img alt="Delete Subscription" src={deleteSubscription} style={{objectFit: "contain", width: "1000px"}}/>
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    To view the details of a particular subscription communication, double-click on a Subscription Communication record.
                    <br/><br/>
                    <img alt="Subscription Communication Detail" src={subscriptionCommunicationDetail} style={{objectFit: "contain", width: "1000px"}}/>
                </li>
            </ul>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Enlil subscriptions have the following attributes.</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    Name - A use assigned name to help identify the subscription.
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    Status - Enabled/Not Enabled. Enabled subscriptions will send transmissions to the specified URL.
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    Event. Select an Enlil event to trigger the transmission.
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    URL. The URL that will receive the POST action.
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    Security Key. Enlil will HMAC the payload using the security key and send the value in the X-ENLIL-SHA-Signature header. Enlil uses the following code to generate HMAC.
                    <br/><br/>

                    <span style={{fontFamily: "courier"}}>
                    computed_hmac = hmac.new([security key].encode(), payload.encode(), hashlib.sha256).digest()<br/>
                    computed_signature = base64.b64encode(computed_hmac).decode()
                    </span>
                    <br/><br/>
                    <br/><br/>
                </li>
            </ul>
        </div>
    )
}